export default __webpack_public_path__ + "static/media/Html-Css.5e7d6343.png";